import React from 'react';
import Hero from '../components/Hero';
import Logline from '../components/Logline';
import Synopsis from '../components/Synopsis';
import ChapterCard from '../components/ChapterCard';
import Character from '../components/Character';
import Reel from '../components/Reel';
import MoodGrid from '../components/MoodGrid';
import StatBlock from '../components/StatBlock';
import Director from '../components/Director';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import SkullLogo from '../components/SkullLogo';
import HolographicSkullBg from '../components/HolographicSkullBg';
import AKREmpire from '../components/AKREmpire';
import {
  NIGHT, BULLET, FISHERMAN, SAGAYAM, HIDDEN, POLICE, VISION,
  PEOPLE, WORLD, MARKET, PRODUCTION,
} from '../mock';

export default function Landing() {
  return (
    <main className="relative overflow-hidden">
      {/* Ambient holographic-skull background video — sits behind every section */}
      <HolographicSkullBg />

      {/* Floating skull logo — top-right corner, fixed across scroll */}
      <div className="fixed top-4 right-4 md:top-6 md:right-6 z-50 pointer-events-none">
        <SkullLogo size={96} />
      </div>

      <div className="relative" style={{ zIndex: 1 }}>
        <Hero />
        <Logline />
        <Synopsis />
        <ChapterCard data={NIGHT} />
        <ChapterCard data={BULLET} showStatus />
        <Character />
        <Reel />
        <ChapterCard data={FISHERMAN} plates={FISHERMAN.plates} />
        <ChapterCard data={SAGAYAM} compact />
        <ChapterCard data={HIDDEN} meta={HIDDEN.meta} plates={HIDDEN.plates} />
        <AKREmpire />
        <ChapterCard data={POLICE} paragraphs={POLICE.paragraphs} plates={POLICE.plates} quote={POLICE.quote} />
        <MoodGrid data={VISION} columns={3} />
        <MoodGrid data={PEOPLE} columns={3} />
        <MoodGrid data={WORLD} columns={3} />
        <StatBlock data={MARKET} />
        <StatBlock data={PRODUCTION} />
        <Director />
        <ContactSection />
        <Footer />
      </div>
    </main>
  );
}
